export const Link = {
    baseStyle: {
        color: 'link.link',
        _hover: {
            color: 'link.hover',
            textDecoration: 'underline'
        },
        _pressed: {
            color: 'link.pressed'
        },
        fontSize: 'm'
    },
    variants: {
        withoutDecoration: {
            color: 'inherit',
            _hover: {
                textDecoration: 'none',
                color: 'inherit'
            },
            _pressed: {
                color: 'inherit'
            }
        }
    }
};

//# sourceMappingURL=link.js.map